import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpDown } from '@/fontawesome.ts';
import Modal from '@/components/ui/Modal.tsx';
import LongTermTradeAdjustementsTable from '@/components/trading/LongTermTradeAdjustementsTable.tsx';
import EditLongTermTradeAdjustementModal from '@/components/admin/recommendations/EditLongTermTradeAdjustementModal.tsx';
import type { LongTermRecommendation, LongTermAdjustement } from '@/models';

interface ViewLongTermRecommendationAdjustmentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  longTermTrade: LongTermRecommendation | null;
  onLongTermRecommendationUpdated: (longTermTrade: LongTermRecommendation) => void;
  isAdmin?: boolean;
}

export default function ViewLongTermRecommendationAdjustmentsModal({
  isOpen,
  onClose,
  longTermTrade,
  onLongTermRecommendationUpdated,
  isAdmin = false,
}: ViewLongTermRecommendationAdjustmentsModalProps) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingAdjustment, setEditingAdjustment] = useState<LongTermAdjustement | null>(null);

  if (!longTermTrade) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={`Einstiege für ${longTermTrade.symbolTicker}`}
        icon={<FontAwesomeIcon icon={faUpDown} className="w-5 h-5 text-purple-600 dark:text-purple-400" />}
        maxWidth="4xl"
      >
        <div className="p-6">
          {longTermTrade.adjustements.length === 0 ? (
            <div className="text-center py-8 text-gray-500 dark:text-gray-400">
              <p className="text-lg font-medium">Keine Einstiege vorhanden</p>
              <p className="text-sm mt-2">
                Für diesen Langzeit Trade wurden noch keine Einstiege vorgenommen.
              </p>
            </div>
          ) : (
            <LongTermTradeAdjustementsTable
              longTermTrade={longTermTrade}
              onEdit={(adjustment) => {
                setEditingAdjustment(adjustment);
                setIsEditModalOpen(true);
              }}
              onDelete={() => {
                // Delete is handled in the table component
              }}
              onLongTermRecommendationUpdated={onLongTermRecommendationUpdated}
              showActions={isAdmin}
            />
          )}
        </div>
      </Modal>

      <EditLongTermTradeAdjustementModal
        isOpen={isEditModalOpen}
        onClose={() => {
          setIsEditModalOpen(false);
          setEditingAdjustment(null);
        }}
        longTermTrade={longTermTrade}
        adjustment={editingAdjustment}
        onAdjustmentUpdated={onLongTermRecommendationUpdated}
      />
    </>
  );
}
